<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Produkt erstellen') }}</h1>
        </div>

        <form @submit.prevent="form.post(route('admin.products.store'))">
            <form-fields :form="form" 
                         :currencies="currencies" 
                         :price-type-options="priceTypeOptions" 
                         :order-units="orderUnits" 
                         :category-tree="categoryTree" 
                         :suppliers="suppliers"
                         />
        </form>
    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {

        props: [
            'currencies',
            'orderUnits',
            'priceTypeOptions',
            'categoryTree',
            'suppliers',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    supplier_id: null,
                    parent_id: null,
                    name: null,
                    slug: null,
                    sku: null,
                    ean: null,
                    enabled: true,
                    main_image_id: null,
                    release_date: null,
                    mdr_classified: false,
                    hazardous_material: false,
                    meta_title: null,
                    meta_description: null,
                    template: null,
//                    sales: 0,
                    supplier_pid: null,
                    supplier_alt_pid: null,
                    manufacturer_pid: null,
                    available_from: null,
                    available_until: null,
                    free_delivery: null,
                    volume: null,
                    width: null,
                    length: null,
                    weight: null,
                    depth: null,
                    manage_stock: null,
                    stock_quantity: null,
                    order_unit_id: null,
                    content_unit_id: null,
                    content_units_per_order_unit: 1,
                    price_quantity: 1,
                    restock_date: null,
                    excerpt: null,
                    description: null,
                    top_seller: null,
                    contact_email: null,
                    delivery_policy: null,
                    purchase_note: null,
                    refund_policy: null,
                    return_policy: null,
                    write_protected: null,
                    keywords: [],
                    categories: [],
                    properties: [],
                    attachments: [],
                    variants: [],
                    product_prices: [],
                }),
            }
        },
        components: {
            FormFields,
        },
        methods: {
        },
    }
</script>